import { Box, Typography } from "@mui/material";
import O2MaticLogo from "../../assets/Logo_white.svg";
import hearth from "../../assets/ic_hearth.svg";
import { colors } from "../../Style";
import { PRO_MODE } from "../../ProSimulator/ProSimulator";
import { useState, useEffect } from "react";
import { ALARM_CODE, getHighestSeverityAlarm } from "../../ProSimulator/Alarm";
import { OximeterState } from "../../ProSimulator/OximeterSimulator";
import { roundToNearest } from "../../Utils";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
export const PauseScreen = (props) => {
  let pro = props.pro;
  let type = props.pro?.pauseScreenValues?.type;
  let isManual = pro?.mode === PRO_MODE.MAN;
  let oximeter = pro?.oximeter;
  const [flowAlarm, setFlowAlarm] = useState(false);

  useEffect(() => {
    let flowError = getHighestSeverityAlarm(props.pro?.alarms, [
      ALARM_CODE.O2_FLOW_ERROR,
      ALARM_CODE.NO_FLOW,
    ]);

    if (flowError != 0 && flowError != undefined) {
      setFlowAlarm(flowError);
    } else {
      setFlowAlarm(null);
    }
  }, [props.pro?.alarms]);

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {type == "Logo" ? (
        <Box
          component="img"
          src={O2MaticLogo}
          alt="O2matic"
          sx={{
            width: "150px",
            p: { sm: 1, sx: 1 },
            position: "absolute",
            left: pro?.pauseScreenValues?.position?.x,
            top: pro?.pauseScreenValues?.position?.y,
          }}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "500px",
            height: "75px",
            justifyContent: "space-around",
            position: "absolute",
            left: pro?.pauseScreenValues?.position?.x,
            top: pro?.pauseScreenValues?.position?.y,
          }}
        >
          <Box
            sx={{
              width: "150px",
              height: "70px",
              display: "flex",
              flexDirection: "row",
              border: "2px solid " + colors().O2,
              borderRadius: "20px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                color: "white",
                fontWeight: "bold",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              {pro?.oxygenOutput > 1500
                ? "15.0+"
                : flowAlarm?.alarmCode === ALARM_CODE.NO_FLOW
                ? "0.0" 
                : (pro?.oxygenOutput / 100).toFixed(1)
              }
            </Typography>
          </Box>

          <Box
            sx={{
              width: "105px",
              height: "90px",
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={hearth}
              alt="Pulse"
              sx={{
                width: "100%",
                height: "100%",
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              }}
            />
            <Typography
              variant="h4"
              sx={{
                color: "white",
                fontWeight: "bold",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              }}
            >
              {oximeter?.state == OximeterState.WEAK_SIGNAL 
                ? <DoDisturbIcon
                    sx={{
                      color: colors().COLORS_ALARM_LOW,
                      position: "absolute",
                      top: "3px",
                      right: "10px",
                      fontSize: 20
                    }}
                  />
                : <></>
              }
              {oximeter?.state == OximeterState.SIGNAL_DATA || oximeter?.state == OximeterState.WEAK_SIGNAL
                ? oximeter?.pulse
                : "---"}
            </Typography>
          </Box>

          <Box
            sx={{
              width: "150px",
              height: "70px",
              display: "flex",
              flexDirection: "row",
              border: "2px solid " + colors().SPO2,
              borderRadius: "20px",
              justifyContent: props.isManual ? "center" : "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                color: "white",
                fontWeight: "bold",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              {oximeter?.state == OximeterState.WEAK_SIGNAL 
                ? <DoDisturbIcon
                    sx={{
                      color: colors().COLORS_ALARM_LOW,
                      position: "absolute",
                      top: "3px",
                      right: "30px",
                      fontSize: 22
                    }}
                  />
                : <></>
              }
              {oximeter?.state == OximeterState.SIGNAL_DATA || oximeter?.state == OximeterState.WEAK_SIGNAL
                ? oximeter.spo2?.toFixed(props.decimalPoints)
                : "---"}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};
